// 协议包上号的账号自带 api 凭据与设备参数（卖号方注册这个号时用的环境）。
// 父页把它们跟 session 一起下发，客户端存下来，每次 initApi 都用它覆盖编译进来的默认值，
// 否则同一个号换了 api_id/设备型号会被 Telegram 当成异常登录。

export type SeatDeviceContext = {
  apiId?: number;
  apiHash?: string;
  deviceModel?: string;
  systemVersion?: string;
  appVersion?: string;
  langCode?: string;
  systemLangCode?: string;
  langPack?: string;
};

const STORAGE_KEY = 'seat_device_context';

export function storeSeatDeviceContext(context: SeatDeviceContext) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(context));
  } catch (err) {
    // 存不下就退回默认设备参数，不影响上号
  }
}

export function loadSeatDeviceContext(): SeatDeviceContext | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const context = JSON.parse(raw) as SeatDeviceContext;
    return context && typeof context === 'object' ? context : undefined;
  } catch (err) {
    return undefined;
  }
}

export function clearSeatDeviceContext() {
  localStorage.removeItem(STORAGE_KEY);
}
